// Live queries pause while the app has been out of sight for a while. A tab left open
// in the background would otherwise re-read list pages on the server all day, every
// time a feed check brings new articles (the database budget is the free plan's
// tightest). Coming back resubscribes; lists show their last rows meanwhile.
import { useSyncExternalStore } from "react";

const AWAY_AFTER = 5 * 60_000;
let awake = true;
let timer: ReturnType<typeof setTimeout> | undefined;
const listeners = new Set<() => void>();
const set = (v: boolean) => { if (awake !== v) { awake = v; listeners.forEach((l) => l()); } };

if (typeof document !== "undefined") {
  const visibility = () => {
    clearTimeout(timer);
    if (document.visibilityState === "visible") set(true);
    else timer = setTimeout(() => set(false), AWAY_AFTER);
  };
  document.addEventListener("visibilitychange", visibility);
  visibility(); // restored/background tabs may already be hidden before this module loads
}

export function useAwake(): boolean {
  return useSyncExternalStore((l) => { listeners.add(l); return () => listeners.delete(l); }, () => awake);
}
